import { DocumentDuplicateIcon } from '@heroicons/react/24/outline';
import { ButtonHTMLAttributes } from 'react';

type DuplicateIconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label?: string;
};

export function DuplicateIconButton({
  label = 'Duplicar',
  className = '',
  ...props
}: DuplicateIconButtonProps) {
  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center rounded-md p-1.5 text-secondary-500 transition-colors hover:bg-sky-50 hover:text-sky-600 ${className}`}
      {...props}
    >
      <DocumentDuplicateIcon className="h-5 w-5" />
    </button>
  );
}
